<template>
  <div>
    <!-- {{ $store.getters.isAgent }} -->
    <h3 style="margin-bottom: 0;">
      References
      <span
        v-if="editAccess"
        style="float: right; cursor: pointer;"
        @click="showAddReferenceDialog()"
        >+</span
      >
    </h3>
    <small v-if="references.length < 3 && editAccess"
      >Please list at least 3 previous placement references; Babysitting,
      Nannying, Daycare, Church Nursery or Summer Camps</small
    >
    <!-- <div
      v-for="(reference, index) of references.filter(
        ref => !isReferenceNote(ref)
      )"
      :key="'ref' + index"
    > -->
    <div
      v-for="(reference, index) in references"
      :key="'ref' + index"
    >
      <div v-if="editAccess || reference.reference_note">
        <hr class="ref-separator" />
        <h5 style="font-weight: 600; margin-bottom: 0;">
          {{ reference.name }}
          <img
            class="edit-button"
            src="../../../assets/img/icons/edit_icon_simple.svg"
            @click="showEditReferenceDialog(reference)"
            v-if="editAccess"
          />
        </h5>
        <DetailSectionColumnLayout
          v-if="editAccess"
          :itemPerColumns="[5, 4]"
          :modelData="reference"
          labelKey="labelDetail"
          :listFields="$store.getters.referenceListFields"
          :listExcludeFields="['name']"
        />

        <div v-if="adminOrEmployer && reference.reference_note">
          <hr />
          <button
            class="mylisting-button dark-button"
            @click="showViewReferenceInterviewNotesModal(reference)"
          >
            View Reference Check Notes
          </button>
        </div>
        <button
          v-if="$store.getters.isAgent === true"
          class="mylisting-button dark-button mt-4"
          @click="showReferenceInterviewNotesModal(reference)"
          style=""
        >
          Log Reference Check Notes
        </button>
      </div>

    </div>
    <!-- <div
      v-for="reference in references.filter(ref => isReferenceNote(ref))"
      :key="reference.id"
      class="px-2"
    >
      <div v-if="adminOrEmployer && reference.reference_note">
        <hr />
        <button
          class="mylisting-button dark-button"
          @click="showViewReferenceInterviewNotesModal(reference)"
        >
          View Reference Check Notes
        </button>
      </div>
      <button
        v-if="$store.getters.isAgent === true"
        class="mylisting-button dark-button mt-4"
        @click="showReferenceInterviewNotesModal(reference)"
        style=""
      >
        Log Reference Check Notes
      </button>
      <hr />
    </div> -->

    <modal
      name="reference-interview-notes-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999;"
    >
      <div class="p-5">
        <h2>Add Reference Interview Notes</h2>
        <hr />
        <!-- <label></label> -->
        <!-- <textarea rows="10" class="form-control" v-model="referenceInterviewNotes"></textarea> -->

        <!-- <label class="top-label">Contact History</label>
        <textarea
          rows="3"
          class="form-control mb-4"
          v-model="contactHistory"
        ></textarea> -->

        <div class="editor">
          <!-- <Modal ref="ytmodal" @onConfirm="addCommand" /> -->
          <editor-menu-bar
            :editor="descriptionEditor"
            v-slot="{ commands, isActive }"
            class="mb-1"
          >
            <div class="menubar">
              <button
                class="btn btn-grey btn-sm menubar__button"
                :class="{ 'is-active': isActive.bold() }"
                @click.prevent="commands.bold"
              >
                <strong>B</strong>
              </button>
              <button
                class="btn btn-grey btn-sm menubar__button"
                :class="{ 'is-active': isActive.italic() }"
                @click.prevent="commands.italic"
              >
                <i>Italics</i>
              </button>
              <button
                class="btn btn-grey btn-sm menubar__button"
                :class="{ 'is-active': isActive.underline() }"
                @click.prevent="commands.underline"
              >
                <u>U</u>
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
                Image
              </button> -->
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="uploadImage(commands.image)">
                Image
              </button> -->
              <!-- https://github.com/scrumpy/tiptap/issues/89 -->
              <!-- https://codesandbox.io/s/j3p0z44155 -->
              <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="openModal(commands.image);">
                Image
              </button> -->
              <button
                class="btn btn-grey btn-sm menubar__button"
                :class="{ 'is-active': isActive.paragraph() }"
                @click.prevent="commands.paragraph"
              >
                p
              </button>
              <button
                class="btn btn-grey btn-sm menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                @click.prevent="commands.heading({ level: 2 })"
              >
                H1
              </button>
              <button
                class="btn btn-grey btn-sm menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 4 }) }"
                @click.prevent="commands.heading({ level: 3 })"
              >
                H2
              </button>
              <button
                class="btn btn-grey btn-sm menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 5 }) }"
                @click.prevent="commands.heading({ level: 4 })"
              >
                H3
              </button>
              <button
                class="btn btn-grey btn-sm menubar__button"
                :class="{ 'is-active': isActive.bullet_list() }"
                @click.prevent="commands.bullet_list"
              >
                List
              </button>
              <button
                class="btn btn-grey btn-sm menubar__button"
                :class="{ 'is-active': isActive.ordered_list() }"
                @click.prevent="commands.ordered_list"
              >
                1. 2. 3...
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
                ""
              </button> -->
              <button
                class="btn btn-grey btn-sm menubar__button"
                :class="{ 'is-active': isActive.horizontal_rule() }"
                @click.prevent="commands.horizontal_rule"
              >
                ---
              </button>
              <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
                Undo
              </button>
              <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
                Redo
              </button> -->
            </div>
          </editor-menu-bar>
          <editor-content class="editor__content" :editor="descriptionEditor" />
        </div>

        <hr />
        <button
          class="mylisting-button secondary-button"
          @click="$modal.hide('reference-interview-notes-modal')"
        >
          Cancel
        </button>
        <button
          v-if="reference.id"
          class="mylisting-button dark-button"
          @click="saveReferenceInterviewNotes(reference)"
          style="float: right;"
        >
          Save
        </button>
      </div>
    </modal>

    <modal
      name="view-reference-interview-notes-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999;"
    >
      <div class="p-5">
        <!-- <h2>Reference notes updated.</h2> -->
        <pre v-html="reference.reference_note"></pre>
        <hr />
        <button
          class="mylisting-button dark-button"
          @click="$modal.hide('view-reference-interview-notes-modal')"
        >
          Done
        </button>
      </div>
    </modal>

    <modal
      name="reference-interview-notes-updated-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999;"
    >
      <div class="p-5">
        <h2>Reference notes updated.</h2>
        <hr />
        <button
          class="mylisting-button dark-button"
          @click="$modal.hide('reference-interview-notes-updated-modal')"
        >
          Done
        </button>
      </div>
    </modal>
    <ReferenceFormDialog
      v-model="isShowReferenceFormDialog"
      :reference="reference"
      :user="user"
      :isAdd="isAddReferenceDialog"
      :isSendRequest="true"
      @saved="getReferences()"
    />
  </div>
</template>

<script>
import axios from "axios";
import DetailSectionColumnLayout from "../../common/DetailSectionColumnLayout";
import ReferenceFormDialog from "../dialogs/ReferenceFormDialog";

// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor
import { Editor, EditorContent, EditorMenuBar } from "tiptap";
// import Icon from 'Components/Icon'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Image // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
} from "tiptap-extensions";

export default {
  props: ["user"],
  components: {
    EditorContent,
    EditorMenuBar,
    DetailSectionColumnLayout,
    ReferenceFormDialog
  },
  data() {
    return {
      references: [],
      reference: {},
      firstName: "",
      lastName: "",
      relationship: "",
      phone: "",
      phone2: "",
      email: "",

      // numChildren: '',
      // ageChildren: '',
      // years: '',
      // frequency: '',
      // jobDescription: '',
      description: "",

      descriptionEditor: null,
      referenceInterviewNotes: "",
      contactHistory: "",
      isShowReferenceFormDialog: false,
      isAddReferenceDialog: false
    };
  },
  computed: {
    editAccess() {
      if (
        this.user.id == this.$store.getters.userID ||
        this.$store.getters.isAgent === true
      ) {
        return true;
      } else {
        return false;
      }
    },
    viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true;
      } else {
        return false;
      }
    },
    adminOrEmployer() {
      if (
        this.$store.getters.isAgent === true ||
        this.$store.getters.isEmployer === true
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.getReferences();
  },
  mounted() {
    this.descriptionEditor = new Editor({
      // content: this.description,
      content: "",
      autoFocus: true,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3, 4, 5] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new Image() // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
      ],
      onUpdate: ({ getJSON, getHTML }) => {
        // this.json = getJSON()
        // this.html = getHTML()
        this.referenceInterviewNotes = getHTML();
      }
    });
  },
  beforeDestroy() {
    this.descriptionEditor.destroy();
  },
  methods: {
    isReferenceNote(ref) {
      return ref.reference_note != null && ref.reference_note !== "";
    },
    getReferences() {
      axios
        .get(`/api/references/?user=${this.user.id}`)
        .then(res => {
          this.references = res.data;
          this.references = this.references.sort((a, b) =>
            a.id > b.id ? 1 : -1
          );
        })
        .catch(error => {
          console.log(error);
        });
    },
    showAddReferenceDialog() {
      this.isAddReferenceDialog = true;
      this.reference = {};
      this.isShowReferenceFormDialog = true;
    },
    showEditReferenceDialog(ref) {
      this.isAddReferenceDialog = false;
      this.reference = { ...ref };
      this.isShowReferenceFormDialog = true;
    },
    showReferenceInterviewNotesModal(reference) {
      this.reference = reference;
      // this.referenceInterviewNotes = reference.reference_note
      // console.log(reference.reference_note)
      if (reference.reference_note) {
        this.descriptionEditor.setContent(reference.reference_note);
        this.referenceInterviewNotes = reference.reference_note;
      } else {
        axios.get(`/api/richtemplates/?agency=${this.$store.getters.agencyID}&selector2=Reference Check`)
          .then(res => {
            console.log(res)
            if (res.data.length) {
              this.descriptionEditor.setContent(res.data[0].body)
              this.referenceInterviewNotes = res.data[0].body
            }
            else {
              this.descriptionEditor.setContent('')
              this.referenceInterviewNotes = ''
            }
          })
      }

      this.contactHistory = reference.text2;

      this.$modal.show("reference-interview-notes-modal");
    },
    saveReferenceInterviewNotes(reference) {
      axios
        .patch(`/api/references/${this.reference.id}/`, {
          reference_note: this.referenceInterviewNotes,
          // text2: this.contactHistory
        })
        .then(res => {
          this.getReferences();
          this.$modal.hide("reference-interview-notes-modal");
          this.$modal.show("reference-interview-notes-updated-modal");
        });
    },
    showViewReferenceInterviewNotesModal(reference) {
      this.reference = reference;
      this.$modal.show("view-reference-interview-notes-modal");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/References.vue